import React, { useState, useEffect } from "react";
import HoursForm from "./HoursForm";
import HoursText from "./HoursText";
import { useEyeconxStore } from "../../../../../store/eyeconxStore";
import Loading from "../../../../common/Loading";
import settingsService from "../../../../../services/settings.service";

const Hours = () => {
    const [hours, setHours] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const clinicId = useEyeconxStore((state) => state.user.clinicId);

    // Mock API fetch
    useEffect(() => {
        const fetchHours = async () => {
            try {
                setIsLoading(true);
               const res = await settingsService.getHours(clinicId)
                //console.log(res)
                setHours(res.data);
            } catch (error) {
                console.error("Error fetching hours:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchHours();
    }, []);

    const handleSave = (updatedHours) => {
        setHours(updatedHours);
        saveHours(updatedHours);
        setIsEditing(false);
       // alert("Hours updated successfully!");
    };
    const saveHours = async (updatedHours) => {

        try{
            setIsLoading(true);
            const res = await settingsService.updateHours(clinicId, updatedHours);
            setHours(res.data);
        } catch(error){
            console.log(error);
        }
        finally{
            setIsLoading(false);
        }
    }
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
       <>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">
                        <i className="bi bi-clock me-2 text-primary"></i> Clinic Hours
                    </h4>
                    <button
                        className={`btn ${isEditing ? "btn-outline-secondary" : "btn-outline-primary"}`}
                        onClick={() => setIsEditing(!isEditing)}
                    >
                        <i className={`bi ${isEditing ? "bi-x-lg" : "bi-pencil"} me-1`}></i>
                        {isEditing ? "Cancel" : "Edit"}
                    </button>
                </div>
                <div className="card-body">
                    {hours && hours.length > 0 && (
                        isEditing ? (
                            <HoursForm hours={hours} onSave={handleSave} onCancel={() => setIsEditing(false)} />
                        ) : (
                            <HoursText hours={hours} />
                        )
                    )}
                </div>
    </>
    );
};

export default Hours;
